import { ScoreReport } from "./EssayEditor";

interface ScoreReportDisplayProps {
  report: ScoreReport;
}

export const ScoreReportDisplay: React.FC<ScoreReportDisplayProps> = ({
  report,
}) => {
  const getScoreColor = (score: number) => {
    if (score >= 85) return "bg-green-500";
    if (score >= 70) return "bg-yellow-500";
    return "bg-red-500";
  };

  const metrics = [
    {
      key: "clarity_and_focus",
      label: "Clarity and Focus",
      description:
        "How well the essay stays on topic and presents a clear central idea.",
    },
    {
      key: "structure_and_organization",
      label: "Structure and Organization",
      description:
        "The logical flow of the essay and the effectiveness of its introduction, body, and conclusion.",
    },
    {
      key: "grammar_and_mechanics",
      label: "Grammar and Mechanics",
      description: "The correctness of grammar, punctuation, and spelling.",
    },
    {
      key: "word_choice_and_tone",
      label: "Word Choice and Tone",
      description:
        "The use of precise and appropriate language and the overall tone of the essay.",
    },
    {
      key: "persuasiveness",
      label: "Persuasiveness",
      description:
        "The strength of the arguments and the use of evidence or examples.",
    },
    {
      key: "creativity_and_originality",
      label: "Creativity and Originality",
      description: "The uniqueness of the ideas and the author's voice.",
    },
  ];

  return (
    <div className="space-y-6">
      <div className="text-center">
        <div
          className={`w-24 h-24 rounded-full flex items-center justify-center mx-auto ${getScoreColor(
            report.overall_score
          )}`}
        >
          <span className="text-white text-3xl font-bold">
            {report.overall_score}
          </span>
        </div>
        <h4 className="text-lg font-semibold mt-4">Overall Score</h4>
      </div>
      <div className="space-y-4">
        {metrics.map((metric) => (
          <div key={metric.key}>
            <div className="flex justify-between items-center mb-1">
              <span className="text-sm font-medium">{metric.label}</span>
              <span className="text-sm font-bold">
                {report[metric.key as keyof ScoreReport]}
              </span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5">
              <div
                className={`h-2.5 rounded-full ${getScoreColor(
                  report[metric.key as keyof ScoreReport] as number
                )}`}
                style={{
                  width: `${report[metric.key as keyof ScoreReport]}%`,
                }}
              ></div>
            </div>
            <p className="text-xs text-gray-500 mt-1">{metric.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
